import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';

const productsCompareRootSelector = createFeatureSelector('productsCompare');

export const getUnifiedCompareData = createSelector(
  productsCompareRootSelector,
  (state) => state?.data || {},
);

export const getActiveGroupId = createSelector(
  productsCompareRootSelector,
  (state) => state?.activeGroupId || '',
);

export const getUserAction = createSelector(
  productsCompareRootSelector,
  (state) =>
    state?.userAction || {
      action: 'request',
      productId: '',
      familyId: '',
      groupId: '',
      groupName: '',
    },
);
